import { Service } 						from "./../../Libs/Service";
import { Request as ServiceRequest } 	from "./../../Libs/Service.Request";
import { Socket as ServiceSocket} 		from "./../../Libs/Service.Socket";

import SetupSettings 					from "./../settings/settings.json";

import { User } 						from "./User";

let Server = new Service({

	Name: "Server",

	Libraries: [ServiceRequest, ServiceSocket],

	Events: {

		"Socket Connection Established": function() {

			if (location.hostname === 'creative-preview-cc.com' || location.hostname === 'creative-preview.cc') {

				this.sendToSocket({
					Init: {
						Preview: {
							projectCodename: location.hash.substr(1).split('/')[0],
							versionId: parseInt(location.hash.substr(1).split('/')[1]) || 0
						}
					}
				});

			} else {
				//TODO remove when login is fixed
				const queryString = window.location.search;
				const urlParams = new URLSearchParams(queryString);
				if (urlParams.get('email')) {
					this.sendToSocket({
						Init: {'email': urlParams.get('email')
						}
					});
				}
				else {
					this.sendToSocket({Init: {}});
				}

			}

		}

	},

	Actions: {

		'*': function(data) {

			console.log('Server Data >>', data);

			setTimeout(() => {

				//Если получен текущий пользователь
				if (User.loaded) {

					Broadcast.call("Server Data Loaded");

				}

			}, 10);

		},

		'Config': function(data) {

			this.Config = data;

		}

	},

	init() {

		this.Config = {};

	},

	connect() {

		if (location.protocol === 'https:') this.connectSocket('wss://' + SetupSettings["domain"] + ':' + SetupSettings["portSSL"]);

		else this.connectSocket('ws://' + SetupSettings["domain"] + ':' + SetupSettings["port"]);

	}

});

//Делаем глобальную ссылку для дебага - чтобы в консоли был виден этот объект сразу
window.Server = Server;

export { Server }
